import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKeyNewsFeed, FeatureStateNewsFeed } from './news-feed.reducer';

const selectFeatureSelector = createFeatureSelector<FeatureStateNewsFeed>(featureKeyNewsFeed);

export const selectNewsFeed = createSelector(selectFeatureSelector, (state: FeatureStateNewsFeed) => state?.newsFeed);
